import moment from "moment";
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { UserChatItem } from "../models/api/UserChatItem";
import { CHAT_DATE_FORMAT, CHAT_TIME_FORMAT } from "../models/constants";
import { fetchVNoteAudioUrlForOverview } from "../services/HelperService";
import { rootStore } from "../StApp";
import AudioComp from "./AudioComp";
import AudioPlayer from "./ChatAdudioPlayer";
import { ChatDateComp } from "./ChatDateComp";
import UserImage from "./UserImage";
import UserText from "./UserText";

const ChatUserItemComp = (props:{chatItem: UserChatItem})=>{

    const [voiceUrl, setVoiceUrl] = useState<string|undefined>('')
    const history = useHistory()

    useEffect(()=>{

        async function act(){ 
            let voiceUrl = await fetchVNoteAudioUrlForOverview(props.chatItem)
            setVoiceUrl(voiceUrl)

        }

        act()
        
    },[])

    function openChat(){

        rootStore.mainStore.setCurrentChatId(props.chatItem.chatId)
        rootStore.mainStore.setCurrentVChatterId(props.chatItem.recepUserId)
        history.push('/stapp/chat')
    }

    return(
        <div className='flex-row chat-overview-item' onClick={openChat} >
            <UserImage userName={props.chatItem.lastChatMsg.senderUserId} /> 
            <div className='flex-column chat-overview-text'>
                <h4 style={{height: 23}}>{props.chatItem.recepUserId}</h4>
                <UserText text={props.chatItem.lastChatMsg.msg} />
            </div>
            <ChatDateComp date={moment(props.chatItem.lastChatMsg.time).format(CHAT_DATE_FORMAT)}
                time={moment(props.chatItem.lastChatMsg.time).format(CHAT_TIME_FORMAT)}
             />
            <AudioPlayer voiceUrl={voiceUrl} />

        </div>
    )

}
export default ChatUserItemComp 